import React from 'react';
import {
  ModalActionContainer,
  ModalActionContent,
  ModalActionHead,
  ModalActionBody,
  ModalActionBodyIcon,
  ModalActionBodyLabel,
  ModalActionBodyDescription,
  ModalActionFooter,
  ModalActionFooterButton,
} from './styles';

const ModalActionSendIdValidation = ({ title, description, open, bodyIcon, rotateIcon, setShowModal, actionFunctionDownButton, actionLabelFunctionDownButton, backgroundIcon }) => {
  return (
    <ModalActionContainer open={open} id="modal-action">
      <ModalActionContent>
        <ModalActionHead>          
        </ModalActionHead>
        <ModalActionBody>
          <ModalActionBodyIcon backgroundIcon={backgroundIcon} rotateIcon={rotateIcon}>
            {bodyIcon}
          </ModalActionBodyIcon>
          <ModalActionBodyLabel>
            {title}
          </ModalActionBodyLabel>
          {description && (
            <ModalActionBodyDescription>
              {description}
            </ModalActionBodyDescription>
          )}
        </ModalActionBody>
        <ModalActionFooter>
          {actionFunctionDownButton && (
            <ModalActionFooterButton onClick={() => actionFunctionDownButton()} id="top-action-button">
              {actionLabelFunctionDownButton}
            </ModalActionFooterButton>
          )}
        </ModalActionFooter>
      </ModalActionContent>
    </ModalActionContainer>
  )
}

export default ModalActionSendIdValidation
